import { createSelector, createSlice } from '@reduxjs/toolkit'
// Create an initial state value for the reducer, with that type

export const StoredSettings = {
    commandServerLocation: 'commandServerLocation',
    controlServerLocation: 'controlServerLocation',

    developerMode: 'developer_mode',

    autoHideDroppedObjects: 'auto_hide_dropped_objects',
    allowDismissTrackingObjects: 'allow_dismiss_tracking_objects',
    bearingUnits: 'bearing_units',
    clockModuleLabels: 'clock_module_labels',
    mapStyle: 'map_style',
    showObjectTrails: 'show_object_trails',
    showOnlyVerifiedObjects: 'show_only_verified_objects',
    displayAltitudeInsteadOfElevation: 'display_altitude_instead_of_elevation',
    videoFeedsShowMask: 'video_feeds_show_mask',
    showDiscardedObjects: 'show_discarded_objects',
    enableMultipleTargetSelect: 'multiple_target_select',

    staticMonitorLowFPSThreshold: 'static_monitor_low_fps_threshold',

    notificationsEnabled: 'notifications_enabled',
    notificationsAudioAlert: 'notifications_audio_alert',
    enableDesktopNotifications: 'notifications_desktop_enabled',

    ui_theme: 'ui_theme'
}

const DEFAULT_SETTINGS = {
    apiLocation: undefined,
    [StoredSettings.autoHideDroppedObjects]: true,
    [StoredSettings.allowDismissTrackingObjects]: false,
    [StoredSettings.bearingUnits]: 'mils',
    [StoredSettings.clockModuleLabels]: true,
    [StoredSettings.mapStyle]: 'streets',
    [StoredSettings.showObjectTrails]: false,
    [StoredSettings.showOnlyVerifiedObjects]: false,
    [StoredSettings.displayAltitudeInsteadOfElevation]: true,
    [StoredSettings.videoFeedsShowMask]: false,

    [StoredSettings.staticMonitorLowFPSThreshold]: 0.5,

    [StoredSettings.notificationsEnabled]: true,
    [StoredSettings.notificationsAudioAlert]: true,

    [StoredSettings.ui_theme]: 'light',

    [StoredSettings.developerMode]: false,
    [StoredSettings.showDiscardedObjects]: false,
    [StoredSettings.enableMultipleTargetSelect]: false,
    [StoredSettings.enableDesktopNotifications]: false,
}

// DEFAULT_SETTINGS.commandServerLocation.websocketProtocol = process.env.REACT_APP_COMMAND_SERVER_PROTOCOL || websocketProtocolFromHttpProtocol(DEFAULT_SETTINGS.commandServerLocation.protocol)
// DEFAULT_SETTINGS.controlServerLocation.websocketProtocol = process.env.REACT_APP_CONTROL_SERVER_PROTOCOL || websocketProtocolFromHttpProtocol(DEFAULT_SETTINGS.controlServerLocation.protocol)

// export const defaultControlServerLocation = DEFAULT_SETTINGS.controlServerLocation;

function loadSettingsFromLocalStorage() {

    let settings = {}
    try {
        const settingString = localStorage.getItem('settings');
        settings = JSON.parse(settingString) || {};
    }
    catch {
        console.warn ('Unable to load setting from local storage')
        settings = {}
    }
    
    return settings;
}

const initialState = {
    user: loadSettingsFromLocalStorage(),
    system: {}
};

// Create the slice and pass in the initial state
const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        updateUserSetting: {
            reducer(state, action) {
                state.user[action.payload.key] = action.payload.value
                localStorage.setItem('settings', JSON.stringify(state.user))
            },
            prepare(key, value) {
                return {
                    payload: { key, value }
                }
            }
        },
        updateUserSettings: (state, action) => {
            for (const [key, value] of Object.entries(action.payload)) {
                state.user[key] = value
            }
            localStorage.setItem('settings', JSON.stringify(state.user))
        },
        updateSystemSettings: (state, action) => {
            state.system = {
                ...state.system,
                ...action.payload.settings
            }
        }
    }
});

// Export the generated reducer function
export default settingsSlice.reducer

// Export the auto-generated action creator with the same name
export const { updateUserSetting, updateUserSettings, updateSystemSettings } = settingsSlice.actions

export const selectUserSetting = (key) => createSelector(
    (state) => state.settings.user,
    (settings) => Object.hasOwn(settings, key) ? settings[key] : DEFAULT_SETTINGS[key]
);
export const selectUserSettings = createSelector(
    (state) => state.settings.user,
    (userSettings) => {
        return {
            ...DEFAULT_SETTINGS,
            ...userSettings
        }
    }
);

export const selectDeveloperMode = selectUserSetting(StoredSettings.developerMode)

export const selectSystemSetting = (key) => createSelector(
    (state) => state.settings.system,
    (settings) => Object.hasOwn(settings, key) ? settings[key] : undefined
);

export const selectAPIRoot = (state) => '/api';

export const selectOfflineMapUrl = selectSystemSetting('offline_map_url');
export const selectCameraFeedsEnabled = selectSystemSetting('camera_feeds_enabled');
export const selectVideoProxyEnabled = selectSystemSetting('video_proxy_enabled');
export const selectEffectorsEnabled = selectSystemSetting('effectors_enabled');






